import { render, staticRenderFns } from "./candidates-source-icon.vue?vue&type=template&id=15294cdb&"
import script from "./candidates-source-icon.vue?vue&type=script&lang=js&"
export * from "./candidates-source-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15294cdb')) {
      api.createRecord('15294cdb', component.options)
    } else {
      api.reload('15294cdb', component.options)
    }
    module.hot.accept("./candidates-source-icon.vue?vue&type=template&id=15294cdb&", function () {
      api.rerender('15294cdb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/staff/candidates/components/candidates-source-icon.vue"
export default component.exports